import type { MeMembershipDto } from '@sara/api-client';

export type OrgEntryDecision = { kind: 'redirect'; slug: string } | { kind: 'show-selector' };

export function decideOrgEntry(input: {
  memberships: MeMembershipDto[];
  lastSlug: string | null;
}): OrgEntryDecision {
  const { memberships, lastSlug } = input;

  if (memberships.length === 0) return { kind: 'show-selector' };
  if (memberships.length === 1) return { kind: 'redirect', slug: memberships[0].organization.slug };

  if (lastSlug && memberships.some((m) => m.organization.slug === lastSlug)) {
    return { kind: 'redirect', slug: lastSlug };
  }

  return { kind: 'show-selector' };
}
